import type { HdcReport } from "../../../../../ExperianPrivateResponse.types";
import {
  ProfileRowVM,
  VectorRowVM,
  mapGeneralProfile,
  mapVectorAnalysis,
} from "../mappers";
import { C } from "../theme";
import { Card } from "../shared/Card";
import { Column, DataTable } from "../shared/DataTable";
import { VectorChip } from "../shared/BehaviourVector";

const profileColumns: Column<ProfileRowVM>[] = [
  { key: "label", header: "Indicador", align: "l", strong: true, render: (p) => p.label },
  { key: "fin", header: "Financiero", render: (p) => p.fin },
  { key: "coop", header: "Cooperativo", render: (p) => p.coop },
  { key: "retail", header: "Real", render: (p) => p.retail },
  { key: "telco", header: "Telcos", render: (p) => p.telco },
  { key: "principal", header: "Principal", render: (p) => p.principal },
  { key: "other", header: "Codeudor/otro", render: (p) => p.other },
];

const vectorColumns = (months: string[]): Column<VectorRowVM>[] => [
  {
    key: "label",
    header: "Sector / entidad",
    align: "l",
    render: (v) => v.label,
    cellStyle: (v) => ({
      color: v.isSector ? C.white : C.text,
      fontWeight: v.isSector ? 700 : 400,
    }),
  },
  ...months.map(
    (m, i): Column<VectorRowVM> => ({
      key: `m${i}`,
      header: m,
      headerStyle: { padding: "10px 2px", fontSize: 10 },
      cellStyle: () => ({ padding: "6px 2px" }),
      render: (v) => <VectorChip cell={v.cells[i]} size="md" />,
    }),
  ),
];

export const MicrocreditoTab = ({ report }: { report: HdcReport }) => {
  const vectors = mapVectorAnalysis(report);
  const profile = mapGeneralProfile(report);
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(min(460px, 100%), 1fr))",
        gap: 20,
      }}
    >
      {vectors.rows.length > 0 && (
        <Card flush title="Análisis de vectores" aside="Más reciente a la izquierda">
          <DataTable
            caption="Análisis de vectores por sector y entidad"
            columns={vectorColumns(vectors.months)}
            rows={vectors.rows}
          />
        </Card>
      )}
      {profile.length > 0 && (
        <Card flush title="Perfil general por sector">
          <DataTable
            caption="Perfil general por sector"
            columns={profileColumns}
            rows={profile}
          />
        </Card>
      )}
    </div>
  );
};
